/**
 * @deprecated use apps/dapp/structure/pv2/vault/configs/queryKeys.ts
 */
export enum QueryKey {
  TOKEN_SUPPLY = 'tokenSupply',
  TVL_PRICE = 'tvlPrice',
  TOKEN_LOCKED = 'tokenLocked',
  WHITELIST = 'whitelist',
  WHITELIST_CLAIM = 'whitelist_claim',
  TOTAL_SDAO_LOCKED = 'totalSdaoLocked',
  LAUNCHPAD_INTEREST = 'load_launchpad_interest',
  KYC_STATUS = 'kyc_status',
  PROJECT_LIST = 'PROJECT_LIST',
  TIER_POOL_LIST = 'TIER_POOL_LIST',
  CHAIN_BLOCK = 'CHAIN_BLOCK',
  PROJECT_DEPOSIT_DETAILS = 'PROJECT_DEPOSIT_DETAILS',
  STAKING_POOL_LIST = 'STAKING_POOL_LIST',
  STAKING_POOL_DATA = 'STAKING_POOL_DATA',
  STAKING_POOL_USER_INFO = 'STAKING_POOL_USER_INFO',
  STAKING_DEPOSIT_CALC_INFO = 'STAKING_DEPOSIT_CALC_INFO',
  STAKING_PROJECT_DETAILS = 'STAKING_PROJECT_DETAILS',
  STAKING_EXTEND_CALC_INFO = 'STAKING_EXTEND_CALC_INFO',
  STAKING_WITHDRAW_CALC_INFO = 'STAKING_WITHDRAW_CALC_INFO',
  WALLET_SREP = 'WALLET_SREP',
  STAKING_PROJECT = 'STAKING_PROJECT',
  DYNAVAULT_STATS = 'DYNAVAULT_STATS',
  DYNAVAULT_VAULT_LIST = 'DYNAVAULT_VAULT_LIST',
  DASHBOARD_LIST = 'DASHBOARD_LIST',
  DYNAVAULT_VAULT_ALLOCATION = 'DYNAVAULT_VAULT_ALLOCATION',
  DYNAVAULT_VAULT_TRANSACTIONS = 'DYNAVAULT_VAULT_TRANSACTIONS',
  DYNAVAULT_VAULT_DECISION_REASONING = 'DYNAVAULT_VAULT_DECISION_REASONING',
}
